import axios from "axios";
import { uniqBy } from "lodash"

export const createVehicle = async (vehicle) => {
    const response = await axios.post(`/api/vehicles`, { vehicle });
    return response.data;
};

export const updateVehicle = async vehicle => {
    const response = await axios.put(`/api/vehicles`, { vehicle });
    return response.data;
};

export const getVehicle = async id => {
    const response = await axios.get(`/api/vehicles/${id}`);
    return response.data;
};

export const getVehicleByPlate = async plate => {
    const response = await axios.get(`/api/vehicles/byplate/${plate}`);
    return response.data;
};

export const getMakes = async () => {
    const params = {
        Auto: 'S',
        Fuoristrada: 'S',
        Microvetture: 'S',
        InVendita: 'S',
        VeicoliCommerciali: 'S'
    }
    const response = await axios.post(`/api/infocar/GetMarche`, { params });
    return response.data.Lista;
};

export const getModels = async (codMarca, codIgnition) => {
    const params = {
        CodiceMarca: codMarca,
        Alimentazione: codIgnition,
    }
    const response = await axios.post(`/api/infocar/GetModelli`, { params });
    return response.data.Lista;
};

export const getPreparations = async (codModello) => {
    const params = {
        CodiceModello: codModello
    }
    const response = await axios.post(`/api/infocar/GetAllestimenti`, { params });

    return uniqBy(response.data.Lista, el => el.DescrizioneCompleta);
};

export const getFromPlate = async (plate) => {
    const params = {
        Targa: plate
    }
    const response = await axios.post(`/api/infocar/GetInfocarDaTarga`, { params });

    return response.data.InfocarDaTarga
};

export const getPlateAnagrafica = async (codInfocarAm) => {
    const params = {
        CodiceInfocarAM: codInfocarAm
    }
    const response = await axios.post(`/api/infocar/GetAnagrafica`, { params });

    return response.data.Anagrafica
};

export const deleteVehicle = async id => {
    const response = await axios.delete(`/api/vehicles/${id}`);
    return response.data;
};
